import { Injectable } from '@angular/core';
import {
	HttpEvent,
	HttpInterceptor,
	HttpHandler,
	HttpRequest,
	HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AlertService } from '@edassist/shared';
import { AppConfigService, AppConfig } from '@edassist/common';

@Injectable()
export class ApiEndpointInterceptor implements HttpInterceptor {
	constructor(private readonly alertService: AlertService) {}

	intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		const appSettings: AppConfig = AppConfigService.getSettings();
		if (appSettings && appSettings.endPoints) {
			const apiUrl = appSettings.endPoints.api;
			const apiReq = req.clone({ url: `${apiUrl}/${req.url}` });

			return next.handle(apiReq).pipe(
				map((event: HttpEvent<any>) => {
					if (
						event instanceof HttpResponse &&
						event.status
							.toString()
							// Check for any status 20x response
							.startsWith('20')
					) {
						// Clear out any prior service errors if future calls are successful per Product
						this.alertService.clear();
					}

					return event;
				})
			);
		}

		return next.handle(req);
	}
}
